export enum StatusTypeEnum {

	RECEIVED_FILES = 5,
	PACKAGES = 10,
	PLANS_AND_PRODUCTS = 15,
	LEGAL_TEXTS = 20,
	CONTRACTS = 25,
	VINS = 30,
	INVOICES = 35,
	PAYMENT = 40,
	ACCOUNT_HISTORY = 45,
	ACCOUNT_HISTORIES = 50,
	APPROPRIATION_RATE = 55,
	FILES = 60
}